import React, { Component } from 'react';
import EmpresaMenu from './EmpresaMenu.jsx';

import MenuBase from "./MenuBase.jsx";

class MenuDesplegable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { cuentaDatos, empresa } = this.props.data;
        const cuentas = [] //empresa.cuentas;   SE COMENTA DEBIDO A QUE LA MODIFICACIÓN DE CUENTAS AHORA SE INVOCA DESDE VISTACLIENTE DIRECTAMENTE
         
        return (
            <div className="row menu-desplegable tarjetas">
                <a className="btn-link btn-link-labeled-primary" onClick={() => this.props.redirectVistaCliente()}>&#60; Volver al listado</a>
                <hr className="separator-line separator-light" />

                <MenuBase cuentas={cuentas} empresa={empresa} cuentaSeleccionada={cuentaDatos}

                    getEmpresaData={this.props.getEmpresaData}
                    getCuentaData={(cuentaId) => this.props.getCuentaData(cuentaId)}
                    getSaldosResumenesData={(cuentaId) => this.props.getSaldosResumenesData(cuentaId)}
                    getIngresoAjustesData={(cuentaId) => this.props.getIngresoAjustesData(cuentaId)}
                    getIngresoCobranzasData={(cuentaId) => this.props.getIngresoCobranzasData(cuentaId)}
                    getTarjetaData={(cuentaId) => this.props.getTarjetaData(cuentaId)} />
            </div>
        );
    }
}

export default MenuDesplegable;